import React from 'react';
import { CheckTwoTone } from '@material-ui/icons';
import './SubscriptionModal.css';

import shannon from '../../assets/shannon.png';


class SubscriptionModal extends React.Component {

  render() {
    const { show, closeModal } = this.props;

    return (
      <div
        aria-hidden="false"
        className="modal nakednews-modal in"
        data-event-tracking={true}
        data-source="home/index"
        data-source-url="https://www.nakednews.com/"
        id="join_modal"
        role="dialog"
        style={{ display: show ? 'block' : 'none' }}
        tabIndex={-1}
      >
        <div
          className="modal-backdrop in"
          style={{ height: '100%' }}
          onClick={closeModal}
        />
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-background">
                <img
                  alt="Shannon"
                  loading="lazy"
                  src={shannon}
                />
              </div>
              <button
                className="close sub-modal-close"
                data-dismiss="modal"
                type="button"
                onClick={closeModal}
              >
                <span>×</span>
              </button>
              <div className="modal-main-container">
                <div className="modal-main">
                  <div className="modal-title">
                    Join Naked News
                  </div>
                  <div className="modal-bullet-points-container">
                    <div className="modal-bullet-points-title">
                      Get Complete Access to:
                    </div>
                    <ul className="list-unstyled modal-bullet-points">
                      <li>
                        <CheckTwoTone />&nbsp;
                        All New Shows in Stunning HD
                      </li>
                      <li>
                        <CheckTwoTone />&nbsp;
                        6Hot New Episodes per Week
                      </li>
                      <li>
                        <CheckTwoTone />&nbsp;
                        On-Demand Access to Our Archives
                      </li>
                      <li>
                        <CheckTwoTone />&nbsp;
                        Fully Naked Amateur Auditions
                      </li>
                    </ul>
                  </div>
                  <a className="btn btn-xxl btn-black action-button" href="/account/purchase">Join now &gt;&gt;</a>
                  <a className="modal-link login-link" href="/account/login">Already a member?</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubscriptionModal;
